import PropTypes from 'prop-types';
import { Trash2 } from 'lucide-react';

export const ConfirmModal = ({ open, onCancel, onConfirm, title, message, confirmText = 'Delete' }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[130] flex items-center justify-center p-4" style={{ background: 'rgba(15,23,42,0.6)', backdropFilter: 'blur(6px)' }}>
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-xl border border-rose-100 overflow-hidden">
        <div className="px-6 py-6 text-center">
          <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center text-rose-500 mb-3" style={{ background: 'rgba(244,63,94,0.10)' }} aria-hidden="true">
            <Trash2 size={20} />
          </div>
          <h4 className="text-base font-extrabold text-[#0d0d0d]">{title}</h4>
          <p className="mt-1 text-[11px] font-medium text-slate-500 leading-relaxed">{message}</p>
        </div>
        <div className="flex border-t border-rose-100">
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 py-3 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 hover:bg-slate-50 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => { onConfirm(); onCancel(); }}
            className="flex-1 py-3 text-xs font-semibold uppercase tracking-[0.14em] bg-rose-500 text-white hover:bg-rose-600 transition-colors"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
};
